import { apiClient } from './apiClient';

export class RedFlagService {
    constructor() {
        this.BASE_URL = '/redFlags';
    }

    /**
     * Get a red flag object by id
     * @param {string} id
     * @returns {Promise<Object>} red flag data
     */
    async getRedFlagById(id) {
        const resp = await apiClient.get(`${this.BASE_URL}/${id}`);
        return resp.data;
    }

    /**
     * Update a red flag by id
     * @param {string} id
     * @param {Object} data - red flag data
     */
    async updateRedFlag(redFlagId, updates) {
        try {
            const response = await apiClient.patch(`${this.BASE_URL}/${redFlagId}`, updates);
            return response
        } catch (error) {
            console.error('Error updating red flag:', error);
            throw error;
        }
    }
}

// Singleton instance for backward compatibility
export const redFlagService = new RedFlagService();
export default redFlagService;
